import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { en } from './translations/en';
import { de } from './translations/de';
import { es } from './translations/es';

// Get saved language from localStorage
const getSavedLanguage = () => {
  try {
    const savedLang = localStorage.getItem('i18nextLng');
    if (savedLang) {
      return savedLang;
    }
  } catch (err) {
    console.warn('Failed to read language from localStorage:', err);
  }
  return 'en';
};

const savedLanguage = getSavedLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      es: { translation: es },
      ar: { translation: {} } // Arabic translations loaded dynamically from API
    },
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

// Save language to localStorage when it changes
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('i18nextLng', lng);
    // Document direction will be updated by RTL component via settings
  } catch (err) {
    console.warn('Failed to save language to localStorage:', err);
  }
});

// Set initial direction based on saved language
// Note: RTL component will manage document.dir based on settings.direction
// This initial setting ensures correct direction on first load before React renders
if (typeof document !== 'undefined' && savedLanguage === 'ar') {
  document.dir = 'rtl';
}
